import type { ApiError } from '@/shared/api/ApiError'

/** Códigos `error.playIntent.*` del backend → copy amigable (claves literales). */
const ERROR_KEYS: Record<string, string> = {
  'error.playIntent.duplicate': 'playIntents.errors.duplicate',
  'error.playIntent.limit': 'playIntents.errors.limit',
  'error.playIntent.window.invalid': 'playIntents.errors.windowInvalid',
  'error.playIntent.forbidden': 'playIntents.errors.forbidden',
  'error.playIntent.game.invalid': 'playIntents.errors.gameInvalid',
  'error.playIntent.not.found': 'playIntents.errors.notFound',
  'error.playIntent.rate.limited': 'playIntents.errors.rateLimited',
  'error.geo.city.not.found': 'playIntents.errors.cityNotFound',
  // Chat del grupo (spec 2026-10-12).
  'error.playIntent.chat.forbidden': 'playIntents.errors.chatForbidden',
  'error.playIntent.chat.waiting': 'playIntents.errors.chatWaiting',
  'error.playIntent.chat.leaveActive': 'playIntents.errors.chatLeaveActive',
}

export const PLAY_INTENT_ERROR_FALLBACK_KEY = 'playIntents.errors.generic'

export function playIntentErrorKey(err: unknown): string {
  const code = (err as Partial<ApiError> | null)?.code
  return (typeof code === 'string' && ERROR_KEYS[code]) || PLAY_INTENT_ERROR_FALLBACK_KEY
}

/** Copy de un error del chat del grupo, o `null` si no es uno propio del chat (→ genérico). */
export function playIntentChatErrorKey(err: unknown): string | null {
  const code = (err as Partial<ApiError> | null)?.code
  return code === 'error.playIntent.chat.forbidden' || code === 'error.playIntent.chat.waiting'
    ? ERROR_KEYS[code]!
    : null
}

/** Para el test de existencia de claves en es/en. */
export const PLAY_INTENT_ERROR_KEYS = [...Object.values(ERROR_KEYS), PLAY_INTENT_ERROR_FALLBACK_KEY]
